export const PermissionV2 = {
    // none: 'NO_ACCESS', // No access
    read: 'READ', // Read only
    create: 'CREATE', // Create
    update: 'UPDATE', // + Update
    delete: 'DELETE', // + Delete (Full)
};
